import { Icon } from '@iconify/react';
import { useRef, useState } from 'react';
import { useSelector } from 'react-redux';

import downloadIcon from '@iconify/icons-eva/download-outline';

// material
import { MenuItem, ListItemText, Box } from '@mui/material';
import PropTypes from 'prop-types';
import moment from 'moment';
import { downloadPositions, getReports } from '../../fetch';
import MenuPopover from '../MenuPopover';
import { useTranslation } from '../../common/LocalizationProvider';
import { selectSession } from '../../createSelectorUtils';

// ----------------------------------------------------------------------

FlightReviewDownload.propTypes = {
  reportTrip: PropTypes.object.isRequired,
  state: PropTypes.object.isRequired,
  setState: PropTypes.func.isRequired,
  setIsOpenSpeedDial: PropTypes.func.isRequired,
  disabled: PropTypes.bool
};

export default function FlightReviewDownload({
  reportTrip,
  state,
  setState,
  setIsOpenSpeedDial,
  disabled
}) {
  const t = useTranslation();
  const ref = useRef(null);
  const session = useSelector(selectSession);

  const [isOpen, setIsOpen] = useState(false);

  const handleDownloadRoute = async (type) => {
    if (!disabled) {
      setState({ ...state, refresh: true });
      if (type === 'kml' || type === 'csv' || type === 'gpx') {
        await downloadPositions(
          type,
          reportTrip.deviceId,
          moment(reportTrip.startTime).toISOString(),
          moment(reportTrip.endTime).toISOString()
        );
      } else {
        await getReports(
          'route',
          reportTrip.deviceId,
          0,
          0,
          moment(reportTrip.startTime).toISOString(),
          moment(reportTrip.endTime).toISOString(),
          true
        );
      }

      setState({ ...state, refresh: false });
    }

    setIsOpen(false);
    setIsOpenSpeedDial(false);
  };

  return (
    <>
      <MenuItem
        sx={{ color: 'text.secondary' }}
        onClick={() => setIsOpen(true)}
        ref={ref}
        disabled={disabled}
      >
        <Icon icon={downloadIcon} width={23} height={23} />
        <ListItemText
          primary={t('FR_Tooltip_Download')}
          primaryTypographyProps={{ variant: 'body2' }}
        />
      </MenuItem>

      <MenuPopover
        open={isOpen}
        anchorEl={ref.current}
        onClose={() => setIsOpen(false)}
        sx={{ width: 200 }}
      >
        <Box>
          <MenuItem onClick={() => handleDownloadRoute('kml')} sx={{ color: 'text.secondary' }}>
            <ListItemText primary="kml" primaryTypographyProps={{ variant: 'body2' }} />
          </MenuItem>
          <MenuItem onClick={() => handleDownloadRoute('gpx')} sx={{ color: 'text.secondary' }}>
            <ListItemText primary="gpx" primaryTypographyProps={{ variant: 'body2' }} />
          </MenuItem>
          {session.administrator && (
            <MenuItem onClick={() => handleDownloadRoute('xlsx')} sx={{ color: 'text.secondary' }}>
              <ListItemText primary="xlsx" primaryTypographyProps={{ variant: 'body2' }} />
            </MenuItem>
          )}
          {session.administrator && (
            <MenuItem onClick={() => handleDownloadRoute('csv')} sx={{ color: 'text.secondary' }}>
              <ListItemText primary="csv" primaryTypographyProps={{ variant: 'body2' }} />
            </MenuItem>
          )}
        </Box>
      </MenuPopover>
    </>
  );
}
